<section class="alc-emoji-section">
  <div class="alc-emoji-category-name">{{ 'm/task-process/emoji-picker/most-used-section-title' | translate }}</div>
  <div class="alc-emojis alc-most-used-emojis">
    <div
      *ngFor="let emojiAndIndex of displayedMostUsedEmojisAndTheirIndex"
      [attr.data-emoji]="emojiAndIndex.emoji"
      [style.background-position]="'-' + emojiAndIndex.spriteIndex * 26 + 'px 0'"></div>
  </div>
</section>

<!-- the list of 1000+ emojis is built with vanilla js otherwise the component is to slow to build in IE11 -->
